import { defineComponent as i, createBlock as p, openBlock as f, unref as e, withCtx as t, createVNode as r, mergeProps as a, renderSlot as s } from "vue";
import { Menu as u, MenuButton as c, MenuItems as _ } from "@headlessui/vue";
import { useBindCx as d } from "@scalar/use-hooks/useBindCx";
import h from "./ScalarDropdownMenu.vue.js";
import B from "../ScalarFloating/ScalarFloating.vue.js";
const y = {}, S = /* @__PURE__ */ i({
  ...y,
  inheritAttrs: !1,
  __name: "ScalarDropdown",
  props: {
    placement: {},
    offset: { type: [Number, Object, Function] },
    resize: { type: Boolean },
    target: {},
    middleware: {},
    teleport: { type: [Boolean, String] }
  },
  setup($) {
    const { cx: l } = d();
    return (o, g) => (f(), p(e(u), null, {
      default: t(({ open: n }) => [
        r(e(B), a(o.$props, {
          placement: o.placement ?? "bottom-start"
        }), {
          floating: t(({ width: m }) => [
            r(h, a({
              is: e(_),
              style: { width: m }
            }, e(l)("max-h-[inherit] max-w-[inherit]")), {
              default: t(() => [
                s(o.$slots, "items", { open: n })
              ]),
              _: 2
            }, 1040, ["is", "style"])
          ]),
          default: t(() => [
            r(e(c), { as: "template" }, {
              default: t(() => [
                s(o.$slots, "default", { open: n })
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["placement"])
      ]),
      _: 3
    }));
  }
});
export {
  S as default
};
